@if (!issued()) {
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">New API key</h2>
    <p class="dialog-subtitle">Lets a script or integration call the API as this company.</p>
  </div>

  <mat-dialog-content class="dialog-content">
    <app-error-banner [message]="errorMessage()" />

    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="name" name="name" placeholder="ERP nightly sync" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Expires in days (optional)</mat-label>
      <input matInput type="number" min="1" [(ngModel)]="expiresInDays" name="expiresInDays" placeholder="90" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions" align="end">
    <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
    <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !name.trim()">
      @if (isSubmitting()) {
        <mat-icon class="spinner">progress_activity</mat-icon>
      }
      {{ isSubmitting() ? 'Creating…' : 'Create key' }}
    </button>
  </mat-dialog-actions>
} @else {
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">API key created</h2>
    <p class="dialog-subtitle">Copy the secret now — it will never be shown again.</p>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="warning">{{ issued()!.warning }}</p>

    <div class="secret-box">
      <code>{{ issued()!.secret }}</code>
      <button mat-icon-button (click)="copySecret()" aria-label="Copy secret" matTooltip="Copy">
        <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
      </button>
    </div>

    @if (copied()) {
      <p class="copied-hint">Copied to clipboard.</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions" align="end">
    <button mat-flat-button class="btn-submit" (click)="done()">Done</button>
  </mat-dialog-actions>
}
